import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  convertCustomerSubscriptionBalanceToWallet,
  getCustomerCheckLeftSubscriptionBalance,
} from "../../../services/CustomerPackageOffer/CustomerPackageOffer";
import { Button } from "primereact/button";
import ButtonLink from "../../../ButtonLink";
import { getUserData } from "../../../utils/localStorage";
import SuccessModal from "../../SuccessModal";

const CustomerSubscriptionTransferToWallet = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { brandId, storeId, storeCustomerId, item, customerData } =
    location.state || {};

  const { userProfileRole } = getUserData();
  const userRole = userProfileRole;
  const [modalVisible, setModalVisible] = useState(false);
  const [apiResStatus, setApiResStatus] = useState(null);
  const [apiResMessage, setApiResMessage] = useState("");

  const [loading, setLoading] = useState(false);

  const [customerCheckLeftSubscriptionBalanceData, setCustomerCheckLeftSubscriptionBalanceData] =
    useState({
      convertBalanceAmount: 0,
    });

  const [activeAlsoApiData, setActiveAlsoApiData] = useState({});

  const fetchCustomerCheckLeftSubscriptionBalance = (activeAlso) => {
    setLoading(true);
    getCustomerCheckLeftSubscriptionBalance(brandId, storeId, item.id, activeAlso)
      .then((response) => {
        if (!response.data.error) {
          setCustomerCheckLeftSubscriptionBalanceData(response.data);
          setActiveAlsoApiData(response.data)
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (brandId && storeId && item?.id) {
      const activeAlso = "no"
      fetchCustomerCheckLeftSubscriptionBalance(activeAlso);
    }
  }, [brandId, storeId, item?.id]);

  const convertSubscriptionBalanceToWallet = (amount) => {

    const payload = {
      convertBalanceAmount: amount,
      activeAlso: "yes"
    };

    convertCustomerSubscriptionBalanceToWallet(
      brandId,
      storeId,
      item.id,
      payload
    )
      .then((response) => {
        if (!response.data.error) {
          setApiResStatus(response.data.status);
          setApiResMessage(response.data.message);
          setModalVisible(true);
          // fetchCustomerCheckLeftSubscriptionBalance("no");
          navigate("/CustomerPackageOffer", {
            state: {
              brandId,
              storeIdValue: storeId,
              storeCustomerId,
              item,
              customerData,
            },
          })
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="flex-1">
      {/* Header */}
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{ "--surface-0": "#1752AA" }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex">
            <div className="ml-3 flex justify-content-center align-items-center">
              <i
                className="pi pi-angle-left"
                onClick={() =>
                  navigate("/CustomerPackageOffer", {
                    state: {
                      brandId,
                      storeIdValue: storeId,
                      storeCustomerId,
                      item,
                      customerData,
                    },
                  })
                }
                style={{
                  fontSize: "27px",
                  cursor: "pointer",
                  color: "#fff",
                }}
              />
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Transfer Subscription to Wallet
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="mx-4 mt-3 flex justify-content-between">
        <p style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}>
          Converted Subscription Balance :{" "}
          <strong>
            {customerCheckLeftSubscriptionBalanceData.convertBalanceAmount}
          </strong>
        </p>
        {activeAlsoApiData.response === "Offer is active." && <div className="mx-4 mt-3 flex" style={{ color: "red" }}>
          <p style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}>

            <strong>
              * Note {" "}{activeAlsoApiData.response}
            </strong>
          </p>

          <Button
            onClick={() =>
              fetchCustomerCheckLeftSubscriptionBalance("yes")
            }
            className="mt-3 mb-3 mx-4 border-round-xl"
          >
            <p className="w-full text-xl font-semibold flex justify-content-center">
              Check Active Also
            </p>
          </Button>
        </div>}
      </div>
      

      <Button
        loading={loading}
        disabled={
          customerCheckLeftSubscriptionBalanceData.convertBalanceAmount === 0
        }
        onClick={() =>
          convertSubscriptionBalanceToWallet(
            customerCheckLeftSubscriptionBalanceData.convertBalanceAmount
          )
        }
        className="mt-3 mb-3 mx-4 border-round-xl"
      >
        <p className="w-full text-xl font-semibold flex justify-content-center">
          Transfer To Wallet
        </p>
      </Button>

      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={apiResStatus === true ? "success" : false}
        text={apiResMessage}
      />
      <ButtonLink />
    </div>
  );
};

export default CustomerSubscriptionTransferToWallet;
